var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import Badge from './Badge';
import messages from './messages';

var UpgradeBadge = function UpgradeBadge(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        rest = _objectWithoutProperties(_ref, ['className']);

    var classes = classNames('upgrade-badge', className);

    return React.createElement(
        Badge,
        _extends({ className: classes }, rest),
        React.createElement(FormattedMessage, messages.upgrade)
    );
};

UpgradeBadge.propTypes = {
    /** Additional class to the component */
    className: PropTypes.string
};
export default UpgradeBadge;
import PropTypes from 'prop-types';